var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5566 25.5C16.7029 25.7533 16.9133 25.9637 17.1667 26.11C17.42 26.2563 17.7074 26.3333 18 26.3333C18.2925 26.3333 18.5799 26.2563 18.8333 26.11C19.0866 25.9637 19.297 25.7533 19.4433 25.5",
    stroke: "#4A5565",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7182 20.7717C10.6093 20.8911 10.5375 21.0394 10.5114 21.1988C10.4853 21.3582 10.5061 21.5218 10.5713 21.6696C10.6365 21.8174 10.7432 21.943 10.8784 22.0313C11.0137 22.1196 11.1717 22.1666 11.3332 22.1667H24.6665C24.828 22.1668 24.9861 22.1199 25.1214 22.0318C25.2568 21.9437 25.3636 21.8182 25.429 21.6705C25.4943 21.5228 25.5153 21.3593 25.4894 21.1999C25.4635 21.0405 25.3919 20.892 25.2832 20.7726C24.1749 19.6301 22.9999 18.4159 22.9999 14.6667C22.9999 13.3407 22.4731 12.0689 21.5354 11.1312C20.5977 10.1935 19.326 9.66675 17.9999 9.66675C16.6738 9.66675 15.402 10.1935 14.4643 11.1312C13.5267 12.0689 12.9999 13.3407 12.9999 14.6667C12.9999 18.4159 11.824 19.6301 10.7182 20.7717Z",
    stroke: "#4A5565",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8C24 5.79086 25.7909 4 28 4V4C30.2091 4 32 5.79086 32 8V8C32 10.2091 30.2091 12 28 12V12C25.7909 12 24 10.2091 24 8V8Z",
    fill: "#ADFF2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b182e4d941cf17968276a58a0db59025.svg";
export { ForwardRef as ReactComponent };